(() => {
  const root = window.Shopify?.routes?.root || '/';
  const money = n => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency', currency:window.Shopify?.currency?.active || 'USD'}).format(n / 100);
  const dialog = document.querySelector('[data-th-dialog]');
  const status = dialog?.querySelector('[data-th-cart-status]');
  let cartBusy = false;
  const box = dialog?.querySelector('[data-th-cart-content]');
  function renderCart(cart) {
    box.replaceChildren();
    document.querySelectorAll('[data-th-count]').forEach(el => el.textContent = cart.item_count);
    for (const item of cart.items) {
      const row = document.createElement('div'); row.className = 'th-cart-line';
      if (item.image) { const img = document.createElement('img'); img.src = item.image + (item.image.includes('?') ? '&' : '?') + 'width=150'; img.alt = item.product_title; img.width = 75; img.height = 75; row.append(img); }
      const details = document.createElement('div'); details.className = 'th-cart-details';
      const title = document.createElement('p'); title.textContent = item.product_title;
      const price = document.createElement('p'); price.textContent = money(item.final_line_price);
      const controls = document.createElement('div'); controls.className = 'th-cart-controls';
      const quantity = document.createElement('span'); quantity.textContent = item.quantity; quantity.setAttribute('aria-label', box.dataset.quantity);
      function control(text, label, next, className) {
        const button = document.createElement('button'); button.type = 'button'; button.textContent = text; button.className = className || 'th-cart-step'; button.setAttribute('aria-label', label + ': ' + item.product_title);
        button.addEventListener('click', () => changeQuantity(item.key, next)); return button;
      }
      controls.append(control('−', box.dataset.decrease, item.quantity - 1), quantity, control('+', box.dataset.increase, item.quantity + 1), control(box.dataset.remove, box.dataset.remove, 0, 'th-cart-remove'));
      details.append(title, price, controls); row.append(details); box.append(row);
    }
    status.textContent = cart.item_count ? money(cart.total_price) : box.dataset.empty;
    dialog.querySelector('.th-button').hidden = !cart.item_count;
  }
  async function changeQuantity(key, quantity) {
    if (cartBusy) return;
    cartBusy = true; box.setAttribute('aria-busy', 'true');
    box.querySelectorAll('button').forEach(button => button.disabled = true);
    const checkout = dialog.querySelector('.th-button'); checkout.hidden = true;
    status.textContent = box.dataset.updating;
    try {
      const response = await fetch(root + 'cart/change.js', {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({id:key, quantity})});
      const cart = await response.json();
      if (!response.ok) throw new Error(cart.description || box.dataset.error);
      renderCart(cart);
    } catch (error) { status.textContent = error.message || box.dataset.error; checkout.hidden = !box.children.length; }
    finally { cartBusy = false; box.removeAttribute('aria-busy'); box.querySelectorAll('button').forEach(button => button.disabled = false); }
  }
  async function showCart() {
    if (!dialog || cartBusy) return;
    if (!dialog.open) dialog.showModal();
    cartBusy = true; box.replaceChildren(); status.textContent = box.dataset.updating;
    dialog.querySelector('.th-button').hidden = true;
    try {
      const response = await fetch(root + 'cart.js');
      if (!response.ok) throw new Error('Unable to load cart');
      renderCart(await response.json());
    } catch (e) { status.textContent = box.dataset.error; }
    finally { cartBusy = false; }
  }
  document.querySelectorAll('[data-th-cart]').forEach(b => b.addEventListener('click', showCart));
  dialog?.querySelector('[data-th-close]')?.addEventListener('click', () => dialog.close());
  dialog?.addEventListener('click', e => { if(e.target === dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();} });
  function init(scope = document) {
    scope.querySelectorAll('[data-th-main]').forEach(main => {
      if (main.dataset.initialized) return; main.dataset.initialized = 'true';
      const slides = [...main.querySelectorAll('[data-th-slide]')];
      const thumbs = [...main.querySelectorAll('[data-th-thumb]')]; let current = 0;
      function select(index) {
        current = (index + slides.length) % slides.length;
        slides.forEach((el,i) => {el.hidden = i !== current;el.querySelectorAll('video').forEach(v=>{if(i!==current)v.pause();});});
        thumbs.forEach((el,i)=>el.setAttribute('aria-pressed', String(i===current)));
      }
      thumbs.forEach((el,i)=>el.addEventListener('click',()=>select(i)));
      main.querySelector('[data-th-prev]')?.addEventListener('click',()=>select(current-1));
      main.querySelector('[data-th-next]')?.addEventListener('click',()=>select(current+1));
      const form = main.querySelector('.th-product-form');
      form?.addEventListener('submit',async e=>{
        e.preventDefault();const button=form.querySelector('[type=submit]');if(button.disabled)return;
        window.hearyTrack?.('product_buy_click');
        const label=button.innerHTML;button.disabled=true;button.textContent=main.dataset.thLoading;
        const message=form.querySelector('[role=status]');message.textContent='';
        try {const response=await fetch(root+'cart/add.js',{method:'POST',body:new FormData(form),headers:{'Accept':'application/json'}});const data=await response.json();if(!response.ok)throw new Error(data.description || main.dataset.thError);window.hearyTrack?.('add_to_cart_success');window.location.assign(document.body.hasAttribute('data-heary-direct-checkout') ? root+'checkout' : root+'discount/BLACKFRIDAY?redirect='+encodeURIComponent(root+'checkout'));}
        catch(error){window.hearyTrack?.('add_to_cart_error');message.textContent=error.message || main.dataset.thError;}
        finally{button.innerHTML=label;button.disabled=false;}
      });
      const sticky=document.querySelector('[data-th-sticky]');
      if(sticky && 'IntersectionObserver' in window){const observer=new IntersectionObserver(entries=>sticky.classList.toggle('is-visible',!entries[0].isIntersecting && entries[0].boundingClientRect.bottom<0));observer.observe(main);}
    });
  }
  init();document.addEventListener('shopify:section:load',e=>init(e.target));
})();
